import { z } from "zod";
import { getEmissionFactorContributions } from "./environmentalProcessor";
import { getEmissionFactorScope } from "../entities/emissionFactor";
/** The three GHG Protocol scopes environmental emissions are grouped into, as
 * the wire and chart series spell them. A LABEL, not a decision — see
 * {@link emissionFactorScopeLabel}. */
export const emissionScopeSchema = z.enum(["Scope 1", "Scope 2", "Scope 3"]);
/**
 * EVERY scope a leaf's emissions land in — not just its primary factor's.
 *
 * Scope is a property of what the EMISSION FACTOR measures, not of which menu
 * the activity was filed under, and the factors are DERIVED from the leaf
 * (see {@link getEmissionFactorContributions}) — never read off the row's
 * stored `emission_factor_type`, which is a cache that has gone stale twice.
 *
 * This answers "which scopes does burning this leaf actually produce
 * emissions in", which is what a target scoped to a GHG scope has to ask:
 * a litre of diesel is Scope 1 for the combustion AND Scope 3 for the
 * well-to-pump production, and a blend adds a second Scope 1 factor as well.
 *
 * Filtering leaves by the primary factor alone would drop every fuel from a
 * Scope 3 target while it is in fact one of the largest contributors to it.
 * That is the same mistake as reading a row's scope off its category, one level
 * down.
 *
 * Empty means the leaf has no factor and so emits in no scope — a real
 * answer, and callers must preserve the distinction from "zero".
 */
export const emissionScopesForCommitment = (commitment) => new Set(getEmissionFactorContributions(commitment).map(({ factorType }) => getEmissionFactorScope(factorType)));
